import { render, staticRenderFns } from "./dealerDetail.vue?vue&type=template&id=3e3cf5b7&scoped=true"
import script from "./dealerDetail.vue?vue&type=script&lang=js"
export * from "./dealerDetail.vue?vue&type=script&lang=js"
import style0 from "./dealerDetail.vue?vue&type=style&index=0&id=3e3cf5b7&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3cf5b7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e3cf5b7')) {
      api.createRecord('3e3cf5b7', component.options)
    } else {
      api.reload('3e3cf5b7', component.options)
    }
    module.hot.accept("./dealerDetail.vue?vue&type=template&id=3e3cf5b7&scoped=true", function () {
      api.rerender('3e3cf5b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inventory/dealerDetail.vue"
export default component.exports